import { Button, Tag, Image } from "antd";

const CardBackgroundPresetColumns = (goToUpdatePage, deletePreset) => [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    width: 60,
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>{value}</span>
    ),
  },
  {
    title: "Görsel",
    dataIndex: "backgroundSmallImageUrl",
    key: "backgroundSmallImageUrl",
    width: 100,
    render: (value) => (
      <span
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
        {value ? (
          <Image
            src={value}
            alt="Preview"
            style={{
              width: 56,
              height: 80,
              objectFit: "cover",
              borderRadius: 4,
            }}
          />
        ) : (
          "-"
        )}
      </span>
    ),
  },
  {
    title: "İsim",
    dataIndex: "name",
    key: "name",
    render: (value) => (
      <span style={{ display: "block" }}>{value}</span>
    ),
  },
  {
    title: "Sıra",
    dataIndex: "displayOrder",
    key: "displayOrder",
    width: 80,
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>{value}</span>
    ),
  },
  {
    title: "Durum",
    dataIndex: "isActive",
    key: "isActive",
    width: 100,
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>
        {value ? (
          <Tag color="green">Aktif</Tag>
        ) : (
          <Tag color="red">Pasif</Tag>
        )}
      </span>
    ),
  },
  {
    title: "İşlemler",
    dataIndex: "operations",
    key: "operations",
    fixed: "right",
    width: 120,
    render: (_, record) => (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Button type="link" onClick={() => goToUpdatePage({ record })}>
          Düzenle
        </Button>
        <Button
          type="link"
          danger
          disabled={!record.isActive}
          onClick={() => deletePreset({ record })}>
          Pasifleştir
        </Button>
      </div>
    ),
  },
];

export { CardBackgroundPresetColumns };
